import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { useSelector } from "react-redux"
import { Routes, Route } from "react-router-dom"
import { layoutTypes } from "./constants/layout"

// Main CRM routes only
import { authProtectedRoutes, publicRoutes } from "./routes"

// Main CRM middleware & layouts only
import Authmiddleware from "./routes/route"
import VerticalLayout from "./components/VerticalLayout/"
import HorizontalLayout from "./components/HorizontalLayout/"
import NonAuthLayout from "./components/NonAuthLayout"

// Styles
import "./assets/scss/theme.scss"

// Firebase (kept as-is)
import { getApps, initializeApp } from "firebase/app"
import { getMessaging, onMessage } from "firebase/messaging"

import fakeBackend from "./helpers/AuthType/fakeBackend"

import {
  handleAutoLogout,
  setupActivityTracking,
} from "../src/pages/Authentication/SessionUtils"

// ----- Firebase init -----
const firebaseConfig = {
  apiKey: "AIzaSyCdZ9qrMOBRexL-cIP7kUkthKeHfZugv3o",
  authDomain: "ecsinternational-8445a.firebaseapp.com",
  databaseURL: "https://ecsinternational-8445a-default-rtdb.firebaseio.com",
  projectId: "ecsinternational-8445a",
  storageBucket: "ecsinternational-8445a.firebasestorage.app",
  messagingSenderId: "260032370320",
  appId: "1:260032370320:web:b240cd8037e96b55ceaa15",
}

let app
if (getApps().length === 0) {
  app = initializeApp(firebaseConfig)
}

const messaging = getMessaging(app)

// ----- Layout resolver for MAIN CRM only -----
const getLayout = layoutType => {
  switch (layoutType) {
    case layoutTypes.VERTICAL:
      return VerticalLayout
    case layoutTypes.HORIZONTAL:
      return HorizontalLayout
    default:
      return VerticalLayout
  }
}

const App = () => {
  const { layoutType } = useSelector(state => ({
    layoutType: state.Layout.layoutType,
  }))

  useEffect(() => {
    const registerServiceWorkerAndListen = async () => {
      try {
        if ("serviceWorker" in navigator) {
          await navigator.serviceWorker.register("/firebase-messaging-sw.js")
          await navigator.serviceWorker.ready
        } else {
          console.log("Service Worker not supported in this browser.")
        }
      } catch (error) {
        console.error("Error during Service Worker registration:", error)
      }
    }

    const listenForMessages = () => {
      onMessage(messaging, payload => {
        console.log("Message received. ", payload)
        alert(
          (payload?.notification?.title ?? "Notification") +
            ": " +
            (payload?.notification?.body ?? "")
        )
      })
    }

    registerServiceWorkerAndListen()
    listenForMessages()
  }, [])

  return (
    <React.Fragment>
      <Routes>
        {/* Public routes (MAIN CRM only) */}
        {publicRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={<NonAuthLayout>{route.component}</NonAuthLayout>}
            key={idx}
          />
        ))}

        {/* Auth-protected routes (MAIN CRM only) */}
        {authProtectedRoutes.map((route, idx) => {
          const Layout = getLayout(layoutType)
          return (
            <Route
              path={route.path}
              element={
                <Authmiddleware>
                  <Layout>{route.component}</Layout>
                </Authmiddleware>
              }
              key={idx}
            />
          )
        })}
      </Routes>
    </React.Fragment>
  )
}

App.propTypes = {
  layout: PropTypes.any,
}

export default App
